export default "__VITE_ASSET__BFWoo8OV__"